import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

function sanitizeFilename(value) {
  return String(value || 'carte-adherent')
    .trim()
    .replace(/[^\w.-]+/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 80);
}

/**
 * Capture la carte adhérent et télécharge un PDF paysage A4.
 * @param {HTMLElement} cardElement — nœud #member-card-print-root
 */
const LANDSCAPE_CARD_WIDTH_PX = 920;

function applyLandscapeLayout(root) {
  if (!root) return () => {};
  root.classList.add('member-card--landscape');
  return () => root.classList.remove('member-card--landscape');
}

export async function exportMemberCardToPdf(cardElement, { filename } = {}) {
  if (!cardElement) {
    throw new Error('Carte introuvable');
  }

  const root = cardElement.closest('.member-card') || cardElement;
  const resetLayout = applyLandscapeLayout(root);

  try {
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const canvas = await html2canvas(cardElement, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: LANDSCAPE_CARD_WIDTH_PX,
      windowWidth: LANDSCAPE_CARD_WIDTH_PX,
      onclone: (doc) => {
        const cloned = doc.getElementById('member-card-print-root');
        if (!cloned) return;
        cloned.classList.add('member-card--landscape');
        const sheet = cloned.querySelector('.member-card__sheet');
        if (sheet) {
          sheet.style.width = `${LANDSCAPE_CARD_WIDTH_PX}px`;
          sheet.style.maxWidth = 'none';
          sheet.style.gridTemplateColumns = '1fr 1fr';
        }
      }
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 6;
    const availWidth = pageWidth - margin * 2;
    const availHeight = pageHeight - margin * 2;
    const canvasRatio = canvas.width / canvas.height;

    let renderWidth = availWidth;
    let renderHeight = renderWidth / canvasRatio;
    if (renderHeight > availHeight) {
      renderHeight = availHeight;
      renderWidth = renderHeight * canvasRatio;
    }

    const x = (pageWidth - renderWidth) / 2;
    const y = (pageHeight - renderHeight) / 2;

    pdf.addImage(imgData, 'PNG', x, y, renderWidth, renderHeight);
    pdf.save(filename || 'carte-adherent.pdf');
  } finally {
    resetLayout();
  }
}

export function buildMemberCardPdfFilename(member) {
  const matricule = sanitizeFilename(member?.matricule);
  const name = sanitizeFilename(
    [member?.nom, member?.prenom].filter(Boolean).join('-')
  );
  const base = matricule || name || 'carte-adherent';
  return `carte-adherent_${base}.pdf`;
}
